export const DPS_REPORT_SUB_TITLE = 'G-POP DPS Newsletter';

export const DPS_REPORT_FORM_CONTROL_PLACEHOLDER = 'None';

// 下载类型
export const DOWNLOAD_PNG_TYPE = 'png';
export const DOWNLOAD_PDF_TYPE = 'pdf';
export const DOWNLOAD_TYPES = [
  { value: DOWNLOAD_PNG_TYPE, text: 'Download PNG File' },
  { value: DOWNLOAD_PDF_TYPE, text: 'Download PDF File' },
];

// 可编辑dps周报页面 几个关键的数值，根据设计稿给的原始尺寸数据，在代码里计算对应的百分比，达到宽高、关键UI块距离的百分比计算
export const DPS_REPORT_STYLE_CFG = {
  // 设计稿上周报头部海报图片的宽度
  POSTER_WIDTH: 1142,
  // 设计稿上周报头部海报图片的高度
  POSTER_HEIGHT: 409,
  // 设计高尚周报头部海报图片内 文字盒子 距离 头部海报图片顶部的距离
  POSTER_DESC_BOX_TOP: 60,
  // 设计高尚周报第一个模块 距离 头部海报图片顶部的距离
  FIRST_CARD_TOP: 206,
};

// 系统最小页面宽度1440宽度下（系统级别设置了页面最小页面宽度为1440px），表格的宽度为1044
export const TABLE_WIDTH_IN_SMALL_SCREEN = 1044;

// 最小页面宽度下，小的列宽
export const SMALL_WIDTH_COLUMN_WIDTH_IN_SMALL_SCREEN = 314;
// 最小页面宽度下，大的列宽
const LARGE_WIDTH_COLUMN_WIDTH_IN_SMALL_SCREEN = 730;

// 小的列宽（百分比）
export const SMALL_WIDTH_COLUMN_WIDTH = `${
  (SMALL_WIDTH_COLUMN_WIDTH_IN_SMALL_SCREEN / TABLE_WIDTH_IN_SMALL_SCREEN) * 100
}%`;
// 大的列宽（百分比）
export const LARGE_WIDTH_COLUMN_WIDTH = `${
  (LARGE_WIDTH_COLUMN_WIDTH_IN_SMALL_SCREEN / TABLE_WIDTH_IN_SMALL_SCREEN) * 100
}%`;
